import { supabase } from '../lib/supabase';

/**
 * Get authorization headers for API requests
 * @returns Headers object with Authorization Bearer token
 */
export const getAuthHeaders = (): HeadersInit => {
  // Get the session synchronously from local storage
  const sessionData = localStorage.getItem(`sb-${process.env.REACT_APP_SUPABASE_URL?.split('//')[1]?.split('.')[0]}-auth-token`);
  
  if (sessionData) {
    try {
      const session = JSON.parse(sessionData);
      if (session?.access_token) {
        return {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json'
        };
      }
    } catch (error) {
      console.error('Error parsing session data:', error);
    }
  }
  
  // Return headers without auth token if no session
  return {
    'Content-Type': 'application/json'
  };
};

/**
 * Get current session asynchronously
 * @returns Current Supabase session or null
 */
export const getCurrentSession = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return session;
};

/**
 * Check if user is authenticated
 * @returns Boolean indicating if user is authenticated
 */
export const isAuthenticated = async (): Promise<boolean> => {
  const session = await getCurrentSession();
  return !!session;
};
